const getFolderEventsById = (folderEvents, id) => {
  return (folderEvents.find((n) => n.id === id) || {}).events || [];
};

export default getFolderEventsById;
